import useGetNearProductsData from './useGetNearProductsData'

export default useGetNearProductsData
